import { Brain } from '@phosphor-icons/react';

const List = ({ title, items, tone = 'border-zinc-700', render }) => (
  Array.isArray(items) && items.length > 0 ? (
    <div>
      <h5 className="label-mini mb-2">{title}</h5>
      <ul className={`space-y-1.5 border-l-2 ${tone} pl-3 text-sm text-zinc-300`}>
        {items.map((it, i) => <li key={i}>{render ? render(it) : `— ${it}`}</li>)}
      </ul>
    </div>
  ) : null
);

export default function ReasoningPanel({ reasoning }) {
  if (!reasoning || typeof reasoning !== 'object') return null;
  return (
    <section className="mt-8 border border-violet-500/30 bg-violet-500/5 p-5" data-testid="reasoning-panel">
      <div className="flex items-center gap-2">
        <Brain weight="fill" className="h-4 w-4 text-violet-300" />
        <h4 className="label-mini text-violet-300">Deep reasoning · how the analyst got here</h4>
      </div>
      {Array.isArray(reasoning.chain) && reasoning.chain.length > 0 && (
        <ol className="mt-4 space-y-2" data-testid="reasoning-chain">
          {reasoning.chain.map((s, i) => (
            <li key={i} className="flex gap-3 text-sm text-zinc-200">
              <span className="label-mini w-6 shrink-0 pt-0.5 text-violet-400">{String(i + 1).padStart(2, '0')}</span><span>{s}</span>
            </li>
          ))}
        </ol>
      )}
      <div className="mt-6 grid gap-6 md:grid-cols-2">
        <List title="Logical fallacies" items={reasoning.fallacies} tone="border-red-500/40"
          render={(f) => <><span className="font-bold text-red-300">{f.name}</span>{f.where ? ` — ${f.where}` : ''}</>} />
        <List title="Hidden assumptions" items={reasoning.assumptions} tone="border-amber-500/40" />
        <List title="Alternative explanations" items={reasoning.alternatives} tone="border-emerald-500/40" />
        <List title="What would change this verdict" items={reasoning.would_change_my_mind} tone="border-sky-500/40" />
      </div>
      {reasoning.confidence_note && <p className="mt-5 text-xs text-zinc-400 italic">{reasoning.confidence_note}</p>}
    </section>
  );
}
